import { lazy, Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

const PickingApp = lazy(() => import('~/apps/smartsend/components/warehouse/PickingApp'));

export default function Component() {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useEffect(() => {
    const title = t('PICKING_APP_TITLE', { defaultValue: 'Picking App' });
    document.title = title;
  }, [t]);

  return (
    <Suspense>
      <PickingApp />
    </Suspense>
  );
}

Component.displayName = 'Picking App';
